"use strict";
// Copyright (C) 2017-2026 Smart code 203358507
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var react_2 = __importDefault(require("@stremio/stremio-icons/react"));
var Button_1 = __importDefault(require("stremio/components/Button"));
var Label_less_1 = __importDefault(require("./Label.less"));
var Label = function (_a) {
    var _b, _c;
    var text = _a.text, icon = _a.icon, disabled = _a.disabled, open = _a.open, onClick = _a.onClick;
    return (react_1.default.createElement(Button_1.default, { className: (0, classnames_1.default)(Label_less_1.default['button'], (_b = {}, _b[Label_less_1.default['open']] = open, _b)), disabled: disabled, onClick: onClick, tabIndex: 0, "aria-haspopup": 'listbox', "aria-expanded": open, role: icon ? 'button' : undefined, "aria-label": icon ? text : undefined, title: icon ? text !== null && text !== void 0 ? text : undefined : undefined },
        react_1.default.createElement("div", { className: Label_less_1.default['text'] }, icon ?
            react_1.default.createElement(react_2.default, { name: icon, className: Label_less_1.default['label-icon'] })
            :
                text),
        !icon &&
            react_1.default.createElement(react_2.default, { name: 'caret-down', className: (0, classnames_1.default)(Label_less_1.default['icon'], (_c = {}, _c[Label_less_1.default['open']] = open, _c)) })));
};
exports.default = Label;
